import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { Upload, PenLine, CheckCircle2 } from 'lucide-react';

export default function CVEntryPage() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-16 max-w-5xl">
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl font-bold mb-3">How would you like to create your CV?</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Whether you already have a CV or you&apos;re starting from scratch, our Gulf/UAE expert engine will optimize your CV for recruiters.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-testid="cv-entry-choice">
          <Link to="/cv-checker" data-testid="entry-have-cv">
            <Card className="p-8 hover:shadow-2xl hover:-translate-y-1 transition-all cursor-pointer border-2 hover:border-[#CE1126] h-full">
              <div className="w-14 h-14 rounded-xl bg-red-50 flex items-center justify-center mb-4">
                <Upload className="w-7 h-7 text-[#CE1126]" />
              </div>
              <h2 className="text-2xl font-bold mb-2">I Already Have a CV</h2>
              <p className="text-gray-600 mb-4">Upload your existing CV and we&apos;ll professionally optimize it — Gulf/UAE style, ATS-safe, fact-locked.</p>
              <ul className="space-y-1 text-sm text-gray-700">
                <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#009639] mt-0.5" /> Free ATS Score</li>
                <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#009639] mt-0.5" /> Expert optimization (AED 29)</li>
                <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#009639] mt-0.5" /> PDF + DOCX download</li>
              </ul>
            </Card>
          </Link>

          <Link to="/cv-builder" data-testid="entry-build-cv">
            <Card className="p-8 hover:shadow-2xl hover:-translate-y-1 transition-all cursor-pointer border-2 hover:border-[#009639] h-full">
              <div className="w-14 h-14 rounded-xl bg-green-50 flex items-center justify-center mb-4">
                <PenLine className="w-7 h-7 text-[#009639]" />
              </div>
              <h2 className="text-2xl font-bold mb-2">I Don&apos;t Have a CV</h2>
              <p className="text-gray-600 mb-4">Answer 7 guided questions and we&apos;ll build a professional Gulf/UAE-ready CV from scratch.</p>
              <ul className="space-y-1 text-sm text-gray-700">
                <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#009639] mt-0.5" /> Guided step-by-step wizard</li>
                <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#009639] mt-0.5" /> Save & continue later</li>
                <li className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-[#009639] mt-0.5" /> PDF + DOCX download</li>
              </ul>
            </Card>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
